import resourceStrings from '../../ResourceStrings';
import { BarGroup } from './BarGroup';
import { BaseCommand, CommandDefinition } from './commands';
import { ESimSmartBars } from './ESimSmartBars';

type DefinitionAliasType = 'esimsmart-detailed-bar' | 'esimsmart-detailed-unbar';

export interface ESimSmartDetailedBarUnbarSettings extends ESimSmartBars<boolean> {
  definitionAlias: DefinitionAliasType;
}

export class ESimSmartDetailedBarUnbarCommand implements ESimSmartDetailedBarUnbarSettings {
  public outgoingInternationalCalls: boolean = false;
  public incomingCalls: boolean = false;
  public roamingOutgoingInternationalCalls: boolean = false;
  public roaming: boolean = false;
  public roamingIncomingCalls: boolean = false;
  public roamingOutgoingCalls: boolean = false;
  public outgoingCalls: boolean = false;
  public gprs: boolean = false;
  public admin: boolean = true;

  public definition: CommandDefinition;
  public definitionAlias: DefinitionAliasType;
  public confirm: boolean;
  public key: string;
  public accountId: number | null = null;
  public networkId: number | null = null;
  public showValidationErrors: boolean;
  public stockIds: number[]; // selected SIMs within command

  constructor(command: BaseCommand) {
    this.definition = command.definition;
    this.definitionAlias = command.definition.jsonAlias as DefinitionAliasType;
    this.key = command.definition.jsonAlias;
    this.confirm = command.confirm;
    this.showValidationErrors = command.showValidationErrors;
    this.stockIds = command.stockIds;
  }

  public isValid() {
    return this.admin || this.hasAdvancedOptionsSelected();
  }

  public hasAdvancedOptionsSelected() {
    return (
      this.outgoingInternationalCalls ||
      this.incomingCalls ||
      this.roaming ||
      this.roamingIncomingCalls ||
      this.roamingOutgoingCalls ||
      this.outgoingCalls ||
      this.gprs
    );
  }
}

export function getESimSmartDetailedBarUnbarOptions(props: ESimSmartDetailedBarUnbarSettings) {
  const {
    admin,
    outgoingCalls,
    outgoingInternationalCalls,
    incomingCalls,
    roamingOutgoingInternationalCalls,
    roaming,
    roamingIncomingCalls,
    roamingOutgoingCalls,
    gprs,
  } = props;
  return [
    {
      label: resourceStrings.admin,
      name: 'admin',
      checked: admin,
      isAdvanced: false,
    },
    {
      label: resourceStrings.outgoingCalls,
      name: 'outgoingCalls',
      checked: outgoingCalls,
      isAdvanced: true,
    },
    {
      label: resourceStrings.data,
      name: 'gprs',
      checked: gprs,
      isAdvanced: true,
    },
    {
      label: resourceStrings.incomingCalls,
      name: 'incomingCalls',
      checked: incomingCalls,
      isAdvanced: true,
    },
    {
      label: resourceStrings.roaming,
      name: 'roaming',
      checked: roaming,
      isAdvanced: true,
    },
    {
      checked: outgoingInternationalCalls,
      isAdvanced: true,
      label: resourceStrings.outgoingInternationalCallsShort,
      name: 'outgoingInternationalCalls',
    },
    {
      label: resourceStrings.roamingIncomingCalls,
      name: 'roamingIncomingCalls',
      checked: roamingIncomingCalls,
      isAdvanced: true,
    },
    {
      label: resourceStrings.roamingOutgoingCalls,
      name: 'roamingOutgoingCalls',
      checked: roamingOutgoingCalls,
      isAdvanced: true,
    },
    {
      label: resourceStrings.roamingOutgoingInternationalCalls,
      name: 'roamingOutgoingInternationalCalls',
      checked: roamingOutgoingInternationalCalls,
      isAdvanced: true,
    },
  ];
}

export function getESimSmartDetailedBarUnbarOptionGroups<T>(
  barSuffix: string,
  featureSuffix: string,
  props: ESimSmartBars<T>,
) {
  const {
    admin,
    outgoingCalls,
    outgoingInternationalCalls,
    incomingCalls,
    roamingOutgoingInternationalCalls,
    roaming,
    roamingIncomingCalls,
    roamingOutgoingCalls,
    gprs,
  } = props;
  const options: BarGroup<T>[] = [
    {
      group: resourceStrings.calls,
      items: [
        {
          label: resourceStrings.admin,
          name: 'admin',
          checked: admin,
          isAdvanced: false,
        },
        {
          label: resourceStrings.outgoingCalls,
          name: 'outgoingCalls',
          checked: outgoingCalls,
          isAdvanced: true,
        },
        {
          label: resourceStrings.incomingCalls,
          name: 'incomingCalls',
          checked: incomingCalls,
          isAdvanced: true,
        },
        {
          label: resourceStrings.roaming,
          name: 'roaming',
          checked: roaming,
          isAdvanced: true,
        },
        {
          checked: outgoingInternationalCalls,
          isAdvanced: true,
          label: resourceStrings.outgoingInternationalCallsShort,
          name: 'outgoingInternationalCalls',
        },
        {
          label: resourceStrings.roamingIncomingCalls,
          name: 'roamingIncomingCalls',
          checked: roamingIncomingCalls,
          isAdvanced: true,
        },
        {
          label: resourceStrings.roamingOutgoingCalls,
          name: 'roamingOutgoingCalls',
          checked: roamingOutgoingCalls,
          isAdvanced: true,
        },
        {
          label: resourceStrings.roamingOutgoingInternationalCalls,
          name: 'roamingOutgoingInternationalCalls',
          checked: roamingOutgoingInternationalCalls,
          isAdvanced: true,
        },
      ],
    },
    {
      group: resourceStrings.data,
      items: [{ label: 'Data', name: 'gprs', checked: gprs, isAdvanced: false }],
    },
  ];

  return options;
}
